import { useQuery } from '@tanstack/react-query'
import { fetchCohortsByDistrict } from '@/services/cohorts'

export function useCohortsByDistrict(districtId: string | undefined) {
  const cohortsQuery = useQuery({
    queryKey: ['cohorts', 'district', districtId],
    queryFn: () => fetchCohortsByDistrict(districtId!),
    enabled: !!districtId,
  })

  return {
    cohorts: cohortsQuery.data,
    isLoading: cohortsQuery.isLoading,
    error: cohortsQuery.error,
  }
}
